export const fileDownload = (url: string, fileName: string) => {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);
};

export const downloadFileFromBase64 = (
    base64String: string,
    fileName: string,
    contentType: string = 'application/pdf',
) => {
    try {
        // Usuń ewentualny prefix data URL, np. "data:application/pdf;base64,"
        const base64Data = base64String.includes(',') ? base64String.split(',')[1] : base64String;

        // Konwersja base64 → bajty
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: contentType });

        // Utwórz URL obiektu i pobierz
        const objectUrl = URL.createObjectURL(blob);
        fileDownload(objectUrl, fileName);

        // Zwolnij pamięć po chwili
        setTimeout(() => {
            URL.revokeObjectURL(objectUrl);
        }, 1000);
    } catch (error) {
        console.error('Error downloading file from base64:', error);
        throw error;
    }
};

export const downloadFileFromBuffer = (
    bufferString: string,
    fileName: string,
    contentType: string = 'application/pdf',
) => {
    try {
        // Convert base64 string to blob
        const byteCharacters = atob(bufferString);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i += 1) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: contentType });

        // Create object URL and download
        const objectUrl = URL.createObjectURL(blob);
        fileDownload(objectUrl, fileName);

        // Clean up the object URL after a short delay to ensure download starts
        setTimeout(() => {
            URL.revokeObjectURL(objectUrl);
        }, 1000);
    } catch (error) {
        console.error('Error downloading file from buffer:', error);
        throw error;
    }
};

export const downloadFileFromHex = (
    hexString: string,
    fileName: string,
    contentType: string = 'application/pdf',
) => {
    try {
        // Remove any whitespace and ensure even length
        const cleanHex = hexString.replace(/\s/g, '');
        if (cleanHex.length % 2 !== 0) {
            throw new Error('Invalid hex string: odd length');
        }

        // Convert hex string to byte array
        const byteArray = new Uint8Array(cleanHex.length / 2);
        for (let i = 0; i < cleanHex.length; i += 2) {
            const hexByte = cleanHex.substr(i, 2);
            byteArray[i / 2] = parseInt(hexByte, 16);
        }

        const blob = new Blob([byteArray], { type: contentType });

        // Create object URL and download
        const objectUrl = URL.createObjectURL(blob);
        fileDownload(objectUrl, fileName);

        // Clean up the object URL after a short delay to ensure download starts
        setTimeout(() => {
            URL.revokeObjectURL(objectUrl);
        }, 1000);
    } catch (error) {
        console.error('Error downloading file from hex:', error);
        throw error;
    }
};
